import { render, staticRenderFns } from "./DataExporter.vue?vue&type=template&id=2e3613db&scoped=true&"
import script from "./DataExporter.vue?vue&type=script&lang=js&"
export * from "./DataExporter.vue?vue&type=script&lang=js&"
import style0 from "./DataExporter.vue?vue&type=style&index=0&id=2e3613db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3613db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3613db')) {
      api.createRecord('2e3613db', component.options)
    } else {
      api.reload('2e3613db', component.options)
    }
    module.hot.accept("./DataExporter.vue?vue&type=template&id=2e3613db&scoped=true&", function () {
      api.rerender('2e3613db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataExporter.vue"
export default component.exports